import { render, staticRenderFns } from "./EditAppsEventGroup.vue?vue&type=template&id=5bcb18fb&scoped=true&"
import script from "./EditAppsEventGroup.vue?vue&type=script&lang=js&"
export * from "./EditAppsEventGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditAppsEventGroup.vue?vue&type=style&index=0&id=5bcb18fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb18fb",
  null
  
)

export default component.exports